import { Turbo } from "@hotwired/turbo-rails"
import "../turbo_config"

// Turbo Drive off by default. Turbo frames and streams (turbo_frame_tag,
// turbo_stream) still work; opt in to Drive per-link with
// data-turbo="true" when you actually want SPA-style navigation.
Turbo.session.drive = true

// Stimulus
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()
const controllers = import.meta.glob("../controllers/**/*_controller.{js,tsx}", { eager: true })
registerControllers(application, controllers)
